// extracted by mini-css-extract-plugin
export default {"frame":"IframePop_frame__kajB-","animate-rotate":"IframePop_animate-rotate__dMnkx"};